import React from 'react';
import {cancel} from '@sail/icons/react/Icon';
import {createViewConfig} from '@sail/engine';
import {Action} from '../Action';
import type {ActionProps} from '../Action';
import {Icon} from '../Icon';
import {useDialogContext} from './useDialogContext';
import {actionButton} from '../../utilStyles/ActionButton';
import {css} from '../../css';

export const DialogCloseButtonConfig = createViewConfig({
  props: {} as ActionProps,
  name: 'DialogCloseButton',
});

export const DialogCloseButton = DialogCloseButtonConfig.createView(
  (props: ActionProps) => {
    const {closeDialog, modality} = useDialogContext();

    if (modality === 'blocking') {
      return null;
    }

    // TODO: SAIL-3215 no hardcoded strings
    return (
      <Action {...props} aria-label="Close" onPress={closeDialog}>
        <Icon icon={cancel} />
      </Action>
    );
  },
  {
    uses: [css({gridArea: 'close'}), ...actionButton],
  },
);
